import { useQuery } from "@tanstack/react-query";
import { useSelector } from "../../../../../store/store";
import { MeetingRequestService } from "../../../../../services/company-office/MeetingRequest.service";

export const useGetMyRequests = () => {
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const response = useQuery({
    queryKey: ["meeting-request-my-requests", currentUserName],
    queryFn: () =>
    MeetingRequestService.getMyMeetingRequests( currentUserName ),
    refetchOnMount:"always"
  });

  return response;
};
